import { Component } from '@angular/core';
import { NavigationService } from '@shared/services/navigation.service';
import { BackbtnserviceService } from './backbtnservice.service';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { WCAGDummyLinkTargetDirective } from '@shared/directives/wcag-dummy-link-target.directive';

@Component({
  selector: 'app-back-btn',
  templateUrl: './back-btn.component.html',
  styleUrls: ['./back-btn.component.scss'],
  imports: [FontAwesomeModule, WCAGDummyLinkTargetDirective]
})
export class BackBtnComponent {

  constructor(
    // private backbtnserviceService: BackbtnserviceService,
    private navigation: NavigationService ) { }

  back(event){
    event && event.preventDefault();
    this.navigation.back();
  }

}
